'use client'

import { noop } from 'lodash'
import { createContext } from 'react'

import { ErrorItem } from '@marketplace-web/core-api/api-client-util'
import { UiState } from '@marketplace-web/shared/ui-state-util'
import {
  RequestReturnDetailsModel,
  ReturnShippingMethodPayingSide,
} from '@marketplace-web/complaints/complaints-data'

type RequestReturnDetailsArgs = {
  transactionId: number
}

export type RequestReturnDetailsContextType = {
  fetchRequestReturnDetails: (args: RequestReturnDetailsArgs) => void
  uiState: UiState
  requestReturnDetails: RequestReturnDetailsModel | undefined
  requestReturnDetailsError: string | undefined
  setRequestReturnDetailsError: (error: string | undefined) => void
  selectedPaymentSide: ReturnShippingMethodPayingSide | null
  updateSelectedPaymentSide: (paymentSide: ReturnShippingMethodPayingSide | null) => void
  addressError: string | null
  setAddressError: (error: string | null) => void
  shippingContactError: ErrorItem | null
  setShippingContactError: (error: ErrorItem | null) => void
}

const RequestReturnDetailsContext = createContext<RequestReturnDetailsContextType>({
  fetchRequestReturnDetails: noop,
  uiState: UiState.Idle,
  requestReturnDetails: undefined,
  requestReturnDetailsError: undefined,
  setRequestReturnDetailsError: noop,
  selectedPaymentSide: null,
  updateSelectedPaymentSide: noop,
  addressError: null,
  setAddressError: noop,
  shippingContactError: null,
  setShippingContactError: noop,
})

export type ContextValuesType = {
  requestReturnDetailsContextValue: RequestReturnDetailsContextType
}

export default RequestReturnDetailsContext
